import './polyfill.js'
import './hasOwlCarousel.js'
import './loader.js'
import './midiaSize.js'
import './loadingAttribute.js'
import './ViewportAnimation.js'
import './voltarTopo.js'